import { render } from "./ToastContainer.vue?vue&type=template&id=0c88d9a4&scoped=true"
import script from "./ToastContainer.vue?vue&type=script&lang=js"
export * from "./ToastContainer.vue?vue&type=script&lang=js"

import "./ToastContainer.vue?vue&type=style&index=0&id=0c88d9a4&lang=scss&scoped=true"

import exportComponent from "/Users/documedias/gitlab/virtuell/ispad2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c88d9a4"]])

export default __exports__